<ng-container>{{data[fieldName] |  currency:'$'}}</ng-container>
